export default __webpack_public_path__ + "static/media/due-date-christine.5411c811.png";